import React from "react";

import WintermuteLogoImage from "../../../img/about/wintermute.png";
import { AuditedSection } from "./elements/AuditedSection";

export const SectionH: React.FC = () => {
  return (
    <div className="d-flex flex-column text-white" id="sectionh">
      <div className="row justify-content-center">
        <h2 className="incubated text-center">Incubated by</h2>
        <div className="d-flex justify-content-center text-center mt-lg-5 mt-md-4 mt-3">
          <a
            href="https://www.wintermute.com/"
            target="_blank"
            className="text-center  mb-0 wintermute-logo"
            rel="nofollow noreferrer"
          >
            <img className="wintermute-logo" src={WintermuteLogoImage} alt="wintermute" />
          </a>
        </div>
        <AuditedSection />
      </div>
    </div>
  );
};
